export const AppStateFlow = (hasStatus) => {
  const states = {
    'app.start': {
      stateName: 'app.start',
      stepTitleKey: 'app.progressBar.start',
      progressbarIcon: 'fa fa-bank',
      progressbarVisible: true,
    },
    'app.oldPortfolio': {
      stateName: 'app.oldPortfolio',
      stepTitleKey: 'app.progressBar.oldPortfolio',
      progressbarVisible: true,
      progressbarIcon: 'fa fa-sign-out',
      requires: ['newBank'],
    },
    'app.transfer': {
      stateName: 'app.transfer',
      stepTitleKey: 'app.progressBar.transfer',
      progressbarVisible: true,
      progressbarIcon: 'fa fa-exchange',
      requires: ['newBank', 'oldPortfolio'],
    },
    'app.newPortfolio': {
      stateName: 'app.newPortfolio',
      stepTitleKey: 'app.progressBar.newPortfolio',
      progressbarVisible: true,
      progressbarIcon: 'fa fa-sign-in',
      requires: ['newBank', 'oldPortfolio', 'transfer'],
    },
    'app.owner': {
      stateName: 'app.owner',
      stepTitleKey: 'app.progressBar.owner',
      progressbarVisible: true,
      progressbarIcon: 'fa fa-user',
      requires: ['newBank', 'oldPortfolio', 'transfer'],
    },
    'app.overview': {
      stateName: 'app.overview',
      stepTitleKey: 'app.progressBar.overview',
      progressbarVisible: true,
      progressbarIcon: 'fa fa-check-square-o',
      requires: ['newBank', 'oldPortfolio', 'transfer', 'newOwners'],
    },
  };
  if (hasStatus) {
    states['app.status'] = { stateName: 'app.status', requires: ['orderId'] };
  } else {
    states['app.finish'] = { stateName: 'app.finish', requires: ['orderId'] };
  }
  return states;
};



// WEBPACK FOOTER //
// ./src/app/app.flow.js